import { render, staticRenderFns } from "./CoreContact.html?vue&type=template&id=65a7658e&external"
import script from "./CoreContact.vue?vue&type=script&lang=js"
export * from "./CoreContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports